(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-sticky"] && !Shopify.designMode) return;
  try {
    
  class FaqScrollspy extends HTMLElement {
    connectedCallback() {
      this.offset = parseInt(this.dataset.offset, 10) || 0;
      this.current = null;
      this.links = Array.from(this.querySelectorAll('[data-nav-for]'));
      if (!this.links.length) return;

      this.groups = this.links
        .map((link) => {
          const el = document.getElementById(link.dataset.navFor);
          return el ? { link, el } : null;
        })
        .filter(Boolean);

      if (!this.groups.length) return;

      // Clicking a nav item scrolls with the same offset the spy uses, so
      // the item you land on is the item that lights up.
      this.links.forEach((link) => {
        link.addEventListener('click', (e) => {
          const target = document.getElementById(link.dataset.navFor);
          if (!target) return;
          e.preventDefault();
          const top = target.getBoundingClientRect().top + window.scrollY - this.offset - 20;
          const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' });
          history.replaceState(null, '', '#' + link.dataset.navFor);
        });
      });

      // Scroll position rather than IntersectionObserver: categories vary
      // wildly in height, and a threshold that suits a twenty-question
      // group never fires for a three-question one.
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.sync();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    onScroll() {
      if (this.pending) return;
      this.pending = true;
      requestAnimationFrame(() => {
        this.pending = false;
        this.sync();
      });
    }

    sync() {
      const line = this.offset + 40;

      // Starts as null rather than the first group: while you're still
      // above the FAQ nothing has been reached yet, so nothing should be
      // marked. The first item only lights up once you actually reach it.
      let active = null;

      // The last group whose top edge has passed the line is the one being
      // read. Walking forward and keeping the last match handles several
      // short groups sitting above the line at once.
      this.groups.forEach((group) => {
        if (group.el.getBoundingClientRect().top <= line) active = group;
      });

      // At the very bottom the final group may never reach the line — if
      // the page can't scroll further, it wins by default.
      const atBottom = window.innerHeight + window.scrollY >= document.body.scrollHeight - 2;
      if (atBottom) active = this.groups[this.groups.length - 1];

      const sameAsBefore = active === null
        ? this.current === null
        : this.current != null && this.current.el === active.el;
      if (sameAsBefore) return;
      this.current = active;

      // Compare elements, not entries: a category has two links pointing
      // at it (nav item and jump button) and both should light up.
      this.groups.forEach((group) => {
        group.link.classList.toggle('is-current', active !== null && group.el === active.el);
      });

      // Keep the active pill in view in the mobile scroller.
      if (active !== null && window.matchMedia('(max-width: 749px)').matches) {
        const pill = this.querySelector('.faq__nav-link.is-current');
        if (pill) pill.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }
  }

  class FaqRow extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('.faq-row__details');
      this.summary = this.querySelector('.faq-row__summary');
      this.body = this.querySelector('.faq-row__body');
      if (!this.details || !this.summary || !this.body) return;

      this.animation = null;
      this.summary.addEventListener('click', this.onClick.bind(this));
    }

    get reduced() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    onClick(event) {
      if (this.reduced) return; // let <details> do its native instant toggle

      event.preventDefault();

      if (this.details.open) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      const spy = this.closest('faq-scrollspy');
      if (spy && spy.dataset.singleOpen === 'true') {
        spy.querySelectorAll('faq-row').forEach((row) => {
          if (row !== this) row.close();
        });
      }

      // The height has to be measured while the element is open, so set
      // the attribute first and animate up from zero.
      this.details.open = true;
      this.animateHeight(0, this.body.scrollHeight);
    }

    close() {
      if (!this.details.open) return;
      this.animateHeight(this.body.scrollHeight, 0, () => {
        this.details.open = false;
      });
    }

    animateHeight(from, to, done) {
      if (this.animation) this.animation.cancel();

      this.animation = this.body.animate(
        { height: [from + 'px', to + 'px'] },
        { duration: 260, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
      );

      this.animation.onfinish = () => {
        this.animation = null;
        this.body.style.height = '';
        if (done) done();
      };
    }
  }

  if (!customElements.get('faq-scrollspy')) customElements.define('faq-scrollspy', FaqScrollspy);
  if (!customElements.get('faq-row')) customElements.define('faq-row', FaqRow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-steps"] && !Shopify.designMode) return;
  try {
    
  class ScrollSteps extends HTMLElement {
    connectedCallback() {
      this.count = Number(this.dataset.stepCount) || 0;
      if (this.count < 1) return;

      this.frames = Array.from(this.querySelectorAll('.scrolly__frame'));
      this.panels = Array.from(this.querySelectorAll('.scrolly__panel'));
      this.icons = Array.from(this.querySelectorAll('.scrolly__icon'));

      this.index = -1;
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const rect = this.getBoundingClientRect();
      const vh = window.innerHeight;

      // Scroll distance available while the sticky child is pinned.
      const scrollable = rect.height - vh;
      if (scrollable <= 0) return;

      // 0 at the moment the section pins, 1 when it releases.
      const progress = Math.min(Math.max(-rect.top / scrollable, 0), 1);

      // Map progress onto a step. The 0.999 keeps progress === 1 from
      // rounding up to an index that doesn't exist.
      const next = Math.min(Math.floor(progress * this.count * 0.999), this.count - 1);

      if (next !== this.index) this.setStep(next);
    }

    setStep(i) {
      this.index = i;

      this.frames.forEach((el, n) => el.classList.toggle('is-active', n === i));
      this.icons.forEach((el, n) => el.classList.toggle('is-active', n <= i));

      this.panels.forEach((el, n) => {
        const active = n === i;
        el.classList.toggle('is-active', active);
        el.toggleAttribute('aria-hidden', !active);
      });
    }
  }

  if (!customElements.get('scroll-steps')) customElements.define('scroll-steps', ScrollSteps);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-spin-split"] && !Shopify.designMode) return;
  try {
    
  class SpinViewer extends HTMLElement {
    connectedCallback() {
      this.urls = (this.dataset.frames || '').split(',').filter(Boolean);
      if (!this.urls.length) return;

      this.canvas = this.querySelector('.spin-viewer__canvas');
      this.ctx = this.canvas.getContext('2d');
      this.bar = this.querySelector('.spin-viewer__bar');
      this.poster = this.querySelector('.spin-viewer__poster');

      this.sensitivity = parseFloat(this.dataset.dragSensitivity) || 6;
      this.reverse = this.dataset.reverse === 'true';
      this.frames = [];
      this.ready = false;

      // Loaded frame sets, keyed by variant id. Swapping back to a strap
      // you've already seen is then instant.
      this.cache = new Map();
      this.dragBound = false;
      this.pendingKey = 'initial';

      // Settings arrive 1-based (frame 28), the array is 0-based (index 27).
      const last = this.urls.length - 1;
      const toIndex = (value, fallback) => {
        const n = parseInt(value, 10);
        return Math.min(Math.max((isNaN(n) ? fallback : n) - 1, 0), last);
      };
      this.introStart = toIndex(this.dataset.introStart, 1);
      this.introEnd = toIndex(this.dataset.introEnd, 1);
      this.introDuration = parseInt(this.dataset.introDuration, 10) || 1200;
      this.introReplay = this.dataset.introReplay === 'true';
      this.introQueued = false;
      this.introDone = false;

      // Park on the start frame so the canvas matches the poster exactly.
      this.index = this.introStart;

      // Don't pull ~2MB of frames until the viewer is near the screen.
      const preloadObserver = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            preloadObserver.disconnect();
            this.loadSet('initial', this.urls);
          }
        },
        { rootMargin: '400px' }
      );
      preloadObserver.observe(this);

      // Separate observer, no rootMargin: the sweep should fire when the
      // viewer is actually on screen, not 400px before it.
      this.introObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.introQueued = true;
              if (this.ready) this.playIntro();
              if (!this.introReplay) this.introObserver.disconnect();
            } else if (this.introReplay) {
              this.resetIntro();
            }
          });
        },
        { threshold: 0.35 }
      );
      this.introObserver.observe(this);
    }

    /* ---- Loading a frame set ---- */

    loadSet(key, urls) {
      this.pendingKey = key;

      const cached = this.cache.get(key);
      if (cached) {
        this.applySet(cached);
        return;
      }

      // Keep the current watch on screen while the new strap downloads,
      // so the swap has no flash of empty canvas.
      if (this.ready) this.dataset.loading = 'true';
      this.bar.style.width = '0%';

      let settled = 0;
      let ok = 0;
      const imgs = [];

      urls.forEach((url, i) => {
        const img = new Image();
        img.decoding = 'async';

        const settle = (loaded) => {
          settled += 1;
          if (loaded) ok += 1;

          if (this.pendingKey === key) {
            this.bar.style.width = (settled / urls.length) * 100 + '%';
          }

          if (settled !== urls.length) return;
          if (this.pendingKey !== key) return; // a newer click already won

          delete this.dataset.loading;

          if (ok === 0) {
            console.warn(
              '[spin-viewer] No frames loaded for "' +
                key +
                '". The filenames in Content > Files do not match what this variant is asking for. ' +
                'Check the metafield and the padding setting. First URL tried:',
              urls[0]
            );
            return; // leave whatever is on screen — poster or previous strap
          }

          if (ok < urls.length) {
            console.warn(
              `[spin-viewer] ${urls.length - ok} of ${urls.length} frames missing on "${key}" — the spin will stutter.`
            );
          }

          this.cache.set(key, imgs);
          this.applySet(imgs);
        };

        img.onload = () => settle(true);
        img.onerror = () => settle(false);

        img.src = url;
        imgs[i] = img;
      });
    }

    applySet(imgs) {
      this.frames = imgs;
      this.ready = true;

      // Hold the current angle, so changing strap reads as a material
      // swap rather than the watch jumping back to the start.
      this.index = Math.min(this.index, imgs.length - 1);

      delete this.dataset.loading;
      this.dataset.ready = 'true';

      this.resize();
      this.draw();

      if (!this.dragBound) {
        this.dragBound = true;
        this.bindDrag();
        new ResizeObserver(() => {
          this.resize();
          this.draw();
        }).observe(this);
      }

      // If the section was already on screen while the frames downloaded,
      // the intro observer has already fired and is waiting on us.
      if (this.introQueued) this.playIntro();
    }

    /* ---- Called by <watch-split> when the customer changes strap ---- */

    setVariant(id, entry) {
      if (!entry) return;
      const key = String(id);

      if (entry.frames && entry.frames.length) {
        this.loadSet(key, entry.frames);
      } else if (entry.photo) {
        this.showPhoto(entry.photo);
      }
    }

    // No frames rendered for this strap yet — show its product photo.
    showPhoto(url) {
      this.pendingKey = 'photo:' + url;
      this.poster.src = url;
      delete this.dataset.ready;
      delete this.dataset.loading;
    }

    /* ---- Intro sweep: start frame -> end frame, once, then stop ---- */

    playIntro() {
      if (this.introDone || this.dataset.touched === 'true') return;
      this.introDone = true;

      const from = this.introStart;
      const to = this.introEnd;

      const finish = () => {
        this.index = to;
        this.draw();
        this.dataset.intro = 'done';
      };

      // Nothing to animate, or the visitor asked for less motion.
      if (from === to || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
        return;
      }

      const startedAt = performance.now();
      const distance = to - from;

      const tick = (now) => {
        if (this.dataset.touched === 'true') return; // visitor grabbed it, hand over

        const t = Math.min((now - startedAt) / this.introDuration, 1);
        const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic: quick start, soft landing
        const next = Math.round(from + distance * eased);

        if (next !== this.index) {
          this.index = next;
          this.draw();
        }

        if (t < 1) {
          this.raf = requestAnimationFrame(tick);
        } else {
          finish();
        }
      };

      this.raf = requestAnimationFrame(tick);
    }

    resetIntro() {
      if (this.dataset.touched === 'true') return; // never yank it back from the visitor
      if (this.raf) cancelAnimationFrame(this.raf);
      this.introDone = false;
      this.introQueued = false;
      delete this.dataset.intro;
      this.index = this.introStart;
      if (this.ready) this.draw();
    }

    resize() {
      const dpr = Math.min(window.devicePixelRatio || 1, 2); // 3x is wasted pixels
      const rect = this.getBoundingClientRect();
      this.canvas.width = Math.max(1, Math.round(rect.width * dpr));
      this.canvas.height = Math.max(1, Math.round(rect.height * dpr));
    }

    draw() {
      const img = this.frames[this.index];
      if (!img || !img.naturalWidth) return; // silently skip a frame that failed

      const cw = this.canvas.width;
      const ch = this.canvas.height;
      const scale = Math.min(cw / img.naturalWidth, ch / img.naturalHeight);
      const w = img.naturalWidth * scale;
      const h = img.naturalHeight * scale;

      this.ctx.clearRect(0, 0, cw, ch);
      this.ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h);
    }

    step(delta) {
      const n = this.frames.length;
      if (!n) return;
      this.index = (((this.index + delta) % n) + n) % n; // wraps both directions
      this.draw();
    }

    bindDrag() {
      let startX = 0;
      let startIndex = 0;
      let dragging = false;

      const takeOver = () => {
        this.dataset.touched = 'true';
        this.dataset.intro = 'done'; // intro is over however far it got
        if (this.raf) cancelAnimationFrame(this.raf);
      };

      this.addEventListener('pointerdown', (e) => {
        if (!this.ready) return;
        dragging = true;
        startX = e.clientX;
        startIndex = this.index;
        this.dataset.dragging = 'true';
        takeOver();
        this.setPointerCapture(e.pointerId);
      });

      this.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const px = (e.clientX - startX) * (this.reverse ? -1 : 1);
        const delta = Math.round(px / this.sensitivity);
        const n = this.frames.length;
        if (!n) return;
        this.index = (((startIndex + delta) % n) + n) % n;
        this.draw();
      });

      const release = (e) => {
        dragging = false;
        this.dataset.dragging = 'false';
        if (this.hasPointerCapture(e.pointerId)) this.releasePointerCapture(e.pointerId);
      };
      this.addEventListener('pointerup', release);
      this.addEventListener('pointercancel', release);

      // Keyboard.
      this.tabIndex = 0;
      this.setAttribute('role', 'img');
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        takeOver();
        this.step(e.key === 'ArrowLeft' ? -1 : 1);
      });
    }
  }

  class WatchSplit extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-view]'));
      this.panels = Array.from(this.querySelectorAll('[data-view-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.view));
      });

      this.spin = this.querySelector('spin-viewer');
      this.photoImg = this.querySelector('.watch-split__fallback-img');

      const dataEl = this.querySelector('.watch-split__data');
      if (!dataEl) return;

      try {
        this.map = JSON.parse(dataEl.textContent);
      } catch (err) {
        console.error('[watch-split] Could not read the variant data.', err);
        return;
      }

      this.lastVariant = this.readVariantId() || this.dataset.variant;

      // Themes announce variant changes in different ways, so listen widely
      // and let the read-back decide whether anything actually changed.
      const sync = () => {
        cancelAnimationFrame(this.syncRaf);
        this.syncRaf = requestAnimationFrame(() => {
          const id = this.readVariantId();
          if (!id || id === this.lastVariant) return;
          this.lastVariant = id;
          this.apply(id);
        });
      };

      ['variant:update', 'variantChange', 'variant:change', 'product-info:loaded'].forEach((name) => {
        document.addEventListener(name, sync);
      });
      document.addEventListener('change', sync);
      window.addEventListener('popstate', sync);
    }

    // Read the selected variant straight from the DOM rather than trusting
    // an event payload — works whether the theme fires an event, re-renders
    // the form, or only updates the URL.
    readVariantId() {
      const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) return String(input.value);
      const param = new URLSearchParams(location.search).get('variant');
      return param ? String(param) : null;
    }

    apply(id) {
      const entry = this.map[id];
      if (!entry) return;

      this.dataset.variant = id;
      if (this.spin) this.spin.setVariant(id, entry);
      if (this.photoImg && entry.photo) {
        this.photoImg.removeAttribute('srcset');
        this.photoImg.src = entry.photo;
      }
    }

    select(view) {
      this.tabs.forEach((tab) => {
        tab.setAttribute('aria-selected', String(tab.dataset.view === view));
      });
      this.panels.forEach((panel) => {
        const active = panel.dataset.viewPanel === view;
        panel.hidden = !active;
        if (!active) {
          const video = panel.querySelector('video');
          if (video) video.pause();
        }
      });
    }
  }

  if (!customElements.get('spin-viewer')) customElements.define('spin-viewer', SpinViewer);
  if (!customElements.get('watch-split')) customElements.define('watch-split', WatchSplit);

  } catch(e) { console.error(e); }
})();
})();
